<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">特集一覧</h2>
        <permission-guard situation="feature_management">
          <v-btn color="primary" dark outlined @click="newFeature">
            <v-icon left> mdi-plus </v-icon>
            新規作成
          </v-btn>
          <v-row class="mt-5">
            <v-col v-for="feature in features" :key="feature.id" lg="4" md="6" sm="12">
              <v-card class="mx-auto" width="500px">
                <v-img :aspect-ratio="10 / 3" :src="headlineImageSrc(feature)">
                </v-img>
                <v-card-title class="pb-2">
                  <v-chip x-small class="mr-2">表示順: {{ feature.priority }}</v-chip>
                  <v-chip
                    v-if="feature.isPublic"
                    class="mr-2 font-weight-bold"
                    x-small
                    label
                    color="primary"
                  >
                    公開
                  </v-chip>
                  <v-chip
                    v-else
                    class="mr-2 font-weight-bold"
                    x-small
                    label
                    color="error"
                  >
                    非公開
                  </v-chip>
                  <span style="font-size: 1.1rem">{{ feature.title }}</span>
                </v-card-title>
                <v-card-text class="text--primary">
                  <div class="caption mb-2">
                    url:
                    <a v-if="feature.isPublic" :href="pageLink(feature)" target="_blank">
                      {{ pageLink(feature) }}
                    </a>
                  </div>
                  <v-chip class="mb-2" small outlined label>
                    {{ featurePageTypes[feature.pageType] }}
                  </v-chip>
                  <v-chip
                    v-if="feature.isDisplayed"
                    class="mb-2"
                    small
                    outlined
                    color="warning"
                  >
                    トップ表示
                  </v-chip>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" text small @click="editFeature(feature)">
                    編集
                  </v-btn>
                  <v-btn color="error" text small @click="destroyFeature(feature.id)">
                    削除
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </permission-guard>
      </v-col>
    </v-row>

    <feature-form :feature="feature" @update-feature="updateFeature" @fetch-features="fetchFeatures" :dialog='dialog' @close-dialog="dialog = false" />
  </v-container>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import headUtilsMixin from '@/mixins/head_utils'
import FeatureForm from './form'
import { mapState } from 'vuex'
import snakecaseKeys from 'snakecase-keys'
import { deserialize } from 'deserialize-json-api'

export default {
  components: {
    PermissionGuard,
    FeatureForm
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '特集一覧',
      dialog: false,
      features: [],
      feature: {
        title: null,
        slug: '',
        description: null,
        headlineImage: null,
        headlineImage3X2: null,
        coverImage3X2: null,
        priority: 0,
        isPublic: true,
        isDisplayed: false,
        pageType: null,
        link: null,
        featureItems: []
      }
    }
  },
  computed: {
    ...mapState({
      featureI18ns: (state) => state.I18n.enums.feature
    }),
    featurePageTypes: function () {
      return snakecaseKeys(this.featureI18ns.pageType)
    }
  },
  mounted: function () {
    this.fetchFeatures()
  },
  methods: {
    fetchFeatures () {
      axios.get('/api/features')
        .then(
          ({ data }) => {
            this.features = deserialize(data).data
          })
        .catch((error) => {
          console.error(error)
        })
    },
    headlineImageSrc (feature) {
      if (feature.headlineImage.url) {
        return feature.headlineImage.url
      } else if (feature.headlineImage3X2.url) {
        return feature.headlineImage3X2.url
      } else {
        return 'http://placehold.jp/eeeeee/cccccc/500x150.png?text=No%20Image'
      }
    },
    pageLink (feature) {
      if (feature.pageType == 'external_page') {
        return feature.link
      } else if (feature.pageType == 'post_summarize') {
        return `/features/${feature.slug}`
      }
    },
    newFeature () {
      this.feature = {
        title: null,
        slug: '',
        description: null,
        headlineImage: null,
        headlineImage3X2: null,
        coverImage3X2: null,
        priority: 0,
        isPublic: true,
        isDisplayed: false,
        pageType: null,
        link: null,
        featureItems: []
      }
      this.dialog = true
    },
    editFeature (feature) {
      this.feature = { ...feature }
      this.dialog = true
    },
    destroyFeature (featureId) {
      axios.delete(`/api/features/${featureId}`).then(
        () => {
          const payload = {
            status: 200,
            message: '特集を削除しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.fetchFeatures()
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.messages
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    updateFeature (feature) {
      this.feature = feature
    }
  }
}
</script>

<style scoped></style>
